export default "__VITE_ASSET__BP3dD6no__"